export interface Error {
    status: string;
    message: string;
    isError: boolean;
    requestSent: boolean;
}


export const initError = (): Error => ({
    status: '',
    message: '',
    isError: false,
    requestSent: false
})


export interface LoginResp {
    userID: string;
    firstname: string;
    lastname: string;
    email: string;

    Token: string;
    isAdmin: boolean;
    username: string;
    password: string;
    custNo: string | string[]; // Support both single and multiple customer numbers
}

export const initLoginResp = (): LoginResp => ({
    username: '',
    password: '',
    Token: '',
    isAdmin: false,
    userID: '',
    firstname: '',
    lastname: '',
    email: '',
    custNo: [],
})




export interface User {
    username: string;
    password: string;
    isLoggedIn: boolean;
    token: string;
    isAdmin: boolean;
    userID: string;
    firstname: string;
    lastname: string;
    email: string;
    custNo: string[]; // Support multiple customer numbers
    newuser: boolean;
}


export const initUser = (): User => ({
    username: '',
    password: '',
    isLoggedIn: false,
    token: '',
    isAdmin: false,
    userID: '',
    firstname: '',
    lastname: '',
    email: '',
    custNo: [],
    newuser: false
})


export interface Quote {
    qNumber: string;
    soldName: string;
    cusPO: string;
    custNo: string;
    partNo: string;
    selected: boolean;
    id: number;
    madeDate: string;
}


export const initQuote = (): Quote => ({
    qNumber: '',
    soldName: '',
    cusPO: '',
    custNo: '',
    partNo: '',
    selected: false,
    id: 0,
    madeDate: ''
})


export interface OpenOrder {
    orderNo: string;
    partNo: string;
    dueDate: string;
    qty: number;
    backOrderQty: number;
    mNumber: string;
    percentComplete: string;
    expNo: string;
}



export interface ShippedOrder {
    orderNo: string;
    partNo: string;
    shipDate: string;
    shipQty: number;
    carrier: string;
    trackingNo: string;
}


export interface OrdersByCOResp {
    openOrders: OpenOrder[];
    shippedOrders: ShippedOrder[];
    canceled?: boolean; // true when the request was superseded by a newer search
}




export interface UserName {
    username: string;
}

export interface PasswordResp {
    password: string;
}